export const formatNumber = (num: number | null | undefined, decimals: number = 1): string => {
  const value = num ?? 0;
  const format = (n: number, suffix: string) => {
    const fixed = n.toFixed(decimals);
    const cleaned = fixed.replace(/\.0+$/, "");
    return `${cleaned}${suffix}`;
  };
  if (value >= 1e12) return format(value / 1e12, "T");
  if (value >= 1e9) return format(value / 1e9, "B");
  if (value >= 1e6) return format(value / 1e6, "M");
  if (value >= 1e3) return format(value / 1e3, "K");
  // Sub-thousand values still need to honour `decimals` — bare toString()
  // would print 124.92153739130435 verbatim. Same trailing-zero cleanup as
  // the suffixed branches.
  return format(value, "");
};

export const formatPercentage = (num: number | null | undefined, decimalPlaces: number = 2): string => {
  const value = num ?? 0;
  const formatted = value.toFixed(decimalPlaces);

  // Add commas to numbers >= 1000
  const [integerPart, decimalPart] = formatted.split('.');
  const formattedInteger = parseInt(integerPart).toLocaleString('en-US');

  return decimalPart ? `${formattedInteger}.${decimalPart}` : formattedInteger;
};
